import { Endpoints } from '@/lib/Endpoints';
import { WebLink } from '@/lib/WebLinks';
import { GenericResponse } from '@/models/GenericResponse';
import { SlugResponse } from '@/models/Slug';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from './ui/dialog';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { ScrollArea } from '@radix-ui/react-scroll-area';
import { SeoView } from './seo/SeoView';
import { Button } from './ui/button';

export default function PrivacyDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const [slug, setSlug] = useState<SlugResponse | null>(null);

  useEffect(() => {
    if (!open) return;
    const privacySlug = WebLink.PRIVACY.replace('/', '');

    async function getPrivacyText() {
      try {
        const params = {
          slug: privacySlug,
        };

        const { data: result } = await axios.get<GenericResponse<SlugResponse>>(
          `${process.env.NEXT_PUBLIC_BASE_URL}${Endpoints.GET_SLUG}`,
          { params },
        );
        setSlug(result.data);
      } catch (e) {
        return null;
      }
    }

    getPrivacyText();
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        {/* <DialogHeader>
          <DialogTitle className="text-[24px] text-hzc_purple_500">
            {slug?.slugProps?.title}
          </DialogTitle>
        </DialogHeader> */}
        <ScrollArea className="flex flex-col gap-2 h-96 overflow-auto">
          <SeoView content={slug?.slugProps?.content || ''} showAll={true} />
        </ScrollArea>
        <DialogFooter className="gap-2">
          <div className="flex flex-row gap-4 justify-end">
            <Button
              className="text-hzc_beige_900 border-1 border-[#5E6AFF1A] bg-[#FFFFFF] hover:bg-[#FFFFFF] transition-all duration-300 hover:scale-105 rounded-full h-[48px]"
              onClick={() => onOpenChange(false)}
            >
              Kapat
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
